/*
 * Globalize Culture ca
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
    let Globalize;

    if (
        typeof require !== 'undefined' &&
        typeof exports !== 'undefined' &&
        typeof module !== 'undefined'
    ) {
        // Assume CommonJS
        Globalize = require('globalize');
    } else {
        // Global variable
        Globalize = window.Globalize;
    }

    Globalize.addCultureInfo('ca-ES', 'default', {
        name: 'ca-ES',
        englishName: 'Catalan',
        nativeName: 'català',
        language: 'ca',
        numberFormat: {
            ',': '.',
            '.': ',',
            NaN: 'NeuN',
            negativeInfinity: '-Infinit',
            positiveInfinity: 'Infinit',
            percent: {
                ',': '.',
                '.': ',',
            },
            currency: {
                pattern: ['-n $', 'n $'],
                ',': '.',
                '.': ',',
                symbol: '€',
            },
        },
        calendars: {
            standard: {
                firstDay: 1,
                days: {
                    names: [
                        'diumenge',
                        'dilluns',
                        'dimarts',
                        'dimecres',
                        'dijous',
                        'divendres',
                        'dissabte',
                    ],
                    namesAbbr: ['dg.', 'dl.', 'dt.', 'dc.', 'dj.', 'dv.', 'ds.'],
                    namesShort: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
                },
                months: {
                    names: [
                        'gener',
                        'febrer',
                        'març',
                        'abril',
                        'maig',
                        'juny',
                        'juliol',
                        'agost',
                        'setembre',
                        'octubre',
                        'novembre',
                        'desembre',
                        '',
                    ],
                    namesAbbr: [
                        'gen',
                        'feb',
                        'març',
                        'abr',
                        'maig',
                        'juny',
                        'jul',
                        'ag',
                        'set',
                        'oct',
                        'nov',
                        'des',
                        '',
                    ],
                },
                AM: null,
                PM: null,
                eras: [{ name: 'd.C.', start: null, offset: 0 }],
                patterns: {
                    d: 'dd/MM/yyyy',
                    D: "dddd d' 'MMMM' de 'yyyy",
                    I: "dddd d' 'MMMM'",
                    t: 'HH:mm',
                    T: 'HH:mm:ss',
                    f: "dddd, d' / 'MMMM' / 'yyyy HH:mm",
                    F: "dddd, d' / 'MMMM' / 'yyyy HH:mm:ss",
                    M: 'dd MMMM',
                    Y: "MMMM' / 'yyyy",
                },
                monthsGenitive: {
                    names: [
                        'de gener',
                        'de febrer',
                        'de març',
                        "d'abril",
                        'de maig',
                        'de juny',
                        'de juliol',
                        "d'agost",
                        'de setembre',
                        "d'octubre",
                        'de novembre',
                        'de desembre',
                        '',
                    ],
                    namesAbbr: [
                        'gen',
                        'feb',
                        'març',
                        'abr',
                        'maig',
                        'juny',
                        'jul',
                        'ag',
                        'set',
                        'oct',
                        'nov',
                        'des',
                        '',
                    ],
                },
            },
        },
    });
})(this);
